import React, { useEffect, useState } from 'react';
import wishlistIcon from 'src/assets/images/no-appointments-icon.png'
import IsFavoriteComponent from '../Customer/ProductsAndServicesComponents/IsFavoriteComponent';
import dummyProductImg from 'src/assets/images/banner-dummy-pic.png'
import PrimaryBtn from 'src/Components/GlobalComponents/primaryBtn';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import httpRequest from 'src/helpers/httpRequest';
import { IPaginated } from 'src/types/paginated';
import qs from "qs";
import { toast } from 'react-toastify';
import { CircularProgress } from '@mui/material';
import PaginationComponet from '../GlobalComponents/PaginationComponet';
import { convertMonthsToReadableFormat } from 'src/helpers/helperFunctions';
import BookAppointmentBtn from '../BookAppointmentBtn';
import { CURRENCY } from 'src/lib/constans';

interface IObj {
    doctorId: string;
    doctorDetails: {
        firstName: string;
        lastName: string;
        coverPhoto: string | null;
        [key: string]: any;
    };
    providersDetails: {
        education: { course: string }[];
        workExperience: string;
    };
    specializationDetails: { name: string }[];
    isLiked: boolean;
    startingPrice: number;
    allReviews: { reviews: [] }[];
    averageStar: number[];
};
interface IResponse {
    documents: IObj[];
    paginated: IPaginated;
};

const FavDoctors: React.FC = () => {
    const [isLoader, setIsLoader] = useState<boolean>(false);
    const [data, setData] = useState<IObj[]>([]);
    const [paginated, setPaginated] = useState<IPaginated>({
        currentPage: 1,
        totalPages: 1,
    });
    const [queryParams, setQueryParams] = useState<{ page: number; limit: number; bool: boolean; }>({
        page: 1,
        limit: 10,
        bool: false,
    });

    const handleRemove = (obj: { productId: string; }) => {
        if (data?.length > 1) {
            setData(prev => prev?.filter(v => v?.doctorId !== obj?.productId));
        } else {
            setQueryParams(prev => ({
                ...prev,
                bool: !prev.bool,
                page: prev?.page > 1 ? prev?.page - 1 : prev?.page
            }));
        }
    };

    const fetch = async () => {
        setIsLoader(true);
        const { bool, ...actulaParams } = queryParams;
        const { res, err } = await httpRequest<IResponse>({ path: `/provider/get/fav-doctors?${qs.stringify(actulaParams)}` });
        if (res) {
            setData(res?.documents || []);
            setPaginated(res?.paginated);
        } else {
            toast(err, { type: "error" });
        }
        setIsLoader(false);
    };
    useEffect(() => {
        fetch();
    }, [queryParams]);

    const PrintItem: React.FC<{ item: IObj }> = ({ item }) => {
        return (
            <div className="my-list-dashbaord-doctor">
                {/* <div className='my-list-dashbaord-doctor-left'> */}
                <div className='my-list-dashbaord-left'>
                    <img
                        src={`${item?.doctorDetails?.coverPhoto}`}
                        alt={`${item?.doctorDetails?.firstName || ""} ${item?.doctorDetails?.lastName || ""}`}
                    />
                </div>
                <div className='customer-pharmacy-card-content-text'>
                    <div className=''>
                        <div className='doctor-list-fav'>
                            <div>
                                <span className='font-size-18px font-Poppins-SemiBold theme-color-green capitalize flex flex-row gap-1 items-center'>{`${item?.doctorDetails?.firstName || ""} ${item?.doctorDetails?.lastName || ""}`}

                                    {item?.doctorDetails?.userVerified === "verified" &&
                                        <span><FontAwesomeIcon icon={faCircleCheck} className="text-[#00443f]" /></span>
                                    }
                                </span>
                                <h6 className="font-Poppins-Medium font-size-16px text-[#202020]">
                                    {item?.specializationDetails &&
                                        <span>
                                            {item?.specializationDetails?.slice(0, 4)?.map(v => v?.name?.length > 15 ? `${v?.name?.slice(0, 15)}...` : v?.name)?.join(" | ")}
                                        </span>
                                    }
                                </h6>
                            </div>

                            <div className='flex justify-end'>
                                <IsFavoriteComponent
                                    productId={item?.doctorId}
                                    isFav={item?.isLiked || false}
                                    category="doctor"
                                    onSuccess={handleRemove}
                                />
                            </div>
                        </div>
                        <p className="text-[#393939] font-size-16px font-Poppins-Regular">
                            {item?.providersDetails?.education &&
                                <span>
                                    {item?.providersDetails?.education?.slice(0, 2)?.map(v => v?.course?.length > 15 ? `${v?.course?.slice(0, 15)}...` : v?.course)?.join(", ")}
                                </span>
                            }
                        </p>
                        <div className="flex gap-1">
                            {[1, 2, 3, 4, 5].map((v) => (
                                <FontAwesomeIcon
                                    key={v}
                                    className={`font-size-16px ${(item?.averageStar?.[0] || 0) >= v ? 'text-[#FF9B29]' : 'text-[#707070]'}`}
                                    icon={faStar}
                                />
                            ))}
                        </div>
                    </div>
                    <div className='flex justify-between items-center'>
                        <div className='doctor-list-fav-inner'>
                            <div className='flex flex-col doctor-list-fav-inner-firts'>
                                <span className="font-size-15px text-[#707070] font-Poppins-Regular">Experience</span>
                                <span className="font-size-15px text-[#202020] font-Poppins-Medium">{convertMonthsToReadableFormat(Number(item?.providersDetails?.workExperience) || 0)}</span>
                            </div>
                            <div className='flex flex-col'>
                                <span className="font-size-15px text-[#707070] font-Poppins-Regular">Reveiws</span>
                                <span className="font-size-15px text-[#202020] font-Poppins-Medium">{item?.allReviews?.[0]?.reviews?.length || 0}</span>
                            </div>
                        </div>
                        <div>
                            <div className='flex justify-end'>
                                <strong className='font-size-18px font-Poppins-Bold mb-2 theme-color-green'>Starting from {CURRENCY} {item?.startingPrice || "-"}</strong>
                            </div>
                            <BookAppointmentBtn
                                doctorId={item?.doctorId}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    };
    return (
        <div className="my-list-dashbaord-main">
            {isLoader ?
                <div className='flex justify-center mt-6'>
                    <CircularProgress style={{ width: 24, height: 24, color: "#00443f" }} />
                </div>
                : data?.length ?
                    data?.map(item => (
                        <PrintItem
                            key={item?.doctorId}
                            item={item}
                        />
                    ))
                    :
                    <div className='parchi-icon-order'>
                        <img src={wishlistIcon} alt="" />
                        <span className="text-center font-Poppins-Medium font-size-22px">No Doctors in the list</span>
                    </div>
            }
            {paginated?.totalPages > 1 &&
                <PaginationComponet
                    total={paginated.totalPages}
                    currentPage={paginated.currentPage}
                    setCurrentPage={(_page) => setQueryParams(prev => ({ ...prev, page: _page }))}
                />
            }
        </div>
    );
};

export default FavDoctors;